// app.js
$(function() {
    var isCollection = $('body').hasClass('collection') ? true : false;
    var isProduct = $('body').hasClass('product') ? true : false;
    var isBlog = ($('body').hasClass('blog') || $('body').hasClass('article')) ? true : false;
    var isPage = $('body').hasClass('page') ? true : false;
    var isFrontPage = $('body').hasClass('index') ? true : false;
    var contentWidth = 950;
    var getJspOffset = function() {
        var viewportWidth = $(window).width();
        var offsetVal = (viewportWidth - contentWidth) / 2;
        return offsetVal < 0 ? 15 : offsetVal;
    }

    $('#nav').find('.has-menu > a').click(function() {
        // hide any active panels
        if (!$(this).hasClass('active')) {
            $('#nav').find('.dropdown.current').toggleClass('current').fadeToggle(250).prev('a').toggleClass('active');
            $('#collection-viewer, #product-slideshow, #collections-listing').animate({opacity:.3}, 250);
        } else {
            $('#collection-viewer, #product-slideshow, #collections-listing').animate({opacity:1}, 250);
        }
        $(this).toggleClass('active')
        $(this).next('.dropdown').toggleClass('current')
            .each(function(){
                if ($(this).css('visibility') == 'hidden') {
                    $(this).hide().css('visibility', 'visible');
                }
                $(this).slideToggle(250);
            });
            return false;
        });

        $('.uber-dropdown', '#nav').each(function() {
            if ($(this).find('ul > li').size() > 4) {
            $(this).find('.container').jScrollPane({ horizontalGutter: 15, verticalGutter: 15 });
        }
    });

    if (isFrontPage) {
        $('.tabs').tabs('.tab-contents > .container', {'effect':'fade'});
        if ($('#frontpage-slides .slide').length > 1) {
            $('#recent-posts').slides({
                container: 'posts-list',
                paginationClass: 'navi',
                generateNextPrev: false,
                generatePagination: false,
                autoHeight: true,
                currentClass: 'active'
            });
            $('#frontpage-slides').cycle({ 
                fx:    'fade', 
                pause:  5,
                pager: '.slides-navi .container',
                activePagerClass: 'current',
                slideResize: 0,
                pagerAnchorBuilder: function(index, slide) {
                    return $('<li><a href="#">' + index + '</a></li>');
                }
            });
            $('#frontpage-slides').cycle('pause');
            $('#frontpage-slides').imagesLoaded(function() {
                $(this).cycle('resume');
            });
        }
    }

    if (isCollection ==  true) {
        var productCount = $('#collection-items').children().size();
        var product = $('#collection-items').find('.product').eq(0);
        var productWidth = parseFloat(product.css('width')) + parseFloat(product.css('marginRight'));

        
            $('#collection-items').css('width', (productWidth * productCount) + 'px');  

            // init jsp
            if ($('#collection-viewer').find('.product').size() > 4) {

                $('#collection-viewer').find('.container').jScrollPane({ horizontalGutter: 0, verticalGutter: 0, hideFocus: true, stickToRight: true }).end().addClass('jsp-ready');
                // apply offset
                $('#collection-items').css('marginLeft', getJspOffset() +'px');
                $(window).resize(function() {
                    $('#collection-items').css('marginLeft', getJspOffset() +'px'); 
                });
          
            } else {
                $('#collection-viewer').addClass('jsp-ready');
            }

        

        

        $("select.select-box-filter").change(function(){
            if ($(this).attr("value") == "") { 
                return false;
            }
            window.location = $(this).attr("value");
        });
    }

    if (isProduct == true && $('#product-slides .photo').length > 1) {
        var ssTop = $('#product-slideshow').offset().top - 30;
        $('#product-slideshow').slides({
            preload: true,
            preloadImage: spinnerURL,
            container: 'slides-container',
            paginationClass: 'slides-navi',
            generateNextPrev: false,
            generatePagination: false,
            autoHeight: true,
            bigTarget: true,
            play: 5000,
            slidesLoaded: function () {
                $('.single-option-selector').trigger('change');
            }
        }).find('#product-slides').addClass('loading')
            .find('.photo').eq(0)
            .find('img').load(function() {
                $('#product-slides .slides_control').css({'height': $(this).height() + 'px'}).animate({'opacity':1}, 300).parent().removeClass('loading');
                $('#product-slideshow').addClass('processed');
            }).each(function() {
                if (this.complete && !$('#product-slideshow').hasClass('processed')) {
                    $(this).trigger('load');
                }
            });
        $('#product-thumbnails a').click(function() {
            if ($(window).scrollTop() > (ssTop)) {
                var diff = $(window).scrollTop() - ssTop;
                var speed = (diff * 0.95) + 200;
                $("html:not(:animated),body:not(:animated)").animate({ scrollTop: ssTop },speed,'easeOutExpo');
            }
        });
    } else if (isProduct == true && $('#product-slides .photo').length == 1) {
        $('#product-thumbnails').hide();
    }

    if (isBlog == true || isPage == true) {
        $('.share-link').click(function() {
            $(this).closest('.post-end').find('.share-box').slideToggle();
            return false;
        });   
        // get tweets
        if (showTweets == true) {
            $.getJSON('https://api.twitter.com/1/statuses/user_timeline.json?screen_name=' + twitterID + '&count=' + parseFloat(numTweets) + '&callback=?&include_rts=true', function(data){
            var tweets = data;
            var frag = $('<ul>', { 'id' : 'tweets', 'class' : 'tweets-container' });
            var fragNavi = $('<ul>', { 'class':'navi' });
            $.each(tweets, function(i) {
                var tweetID = this.id_str;
                var tweetText = linkifyTweet(this.text);
                var timeago = relativeTime(this.created_at);
                var permalink = 'http://twitter.com/' + twitterID + '/status/' + tweetID;
                var output  = $('<div>', { 'class' : 'tweet' });      
                output.html('<p class="tweet-text">' + tweetText + '</p>' +
                '<p class="tweet-meta"><a class="timestamp" href="' + permalink + '" time="' + this.created_at + '" target="_blank">' + timeago + '</a> &mdash; <a class="reply" href="http://twitter.com/?status=@' + twitterID + '&in_reply_to_status_id=' + tweetID + '&in_reply_to=' + twitterID + '" target="_blank">Reply</a></p>');
                output.appendTo(frag);
                fragNavi.append('<li><a href="#">' + (i+1) + '</a></li>');
            });
            $('#twitter')
                .find('.navigation').append(fragNavi).append(' of ' + numTweets)
                .end()
                .find('.loading').replaceWith(frag)
                .end()
                .slides({
                    container: 'tweets-container',
                    paginationClass: 'navi',
                    generateNextPrev: false,
                    generatePagination: false,
                    autoHeight: true,
                    currentClass: 'active'
                }).addClass('processed');
            });
        }
    }
});

$(document).ready(function(){
    var isCollection = $('body').hasClass('collection') ? true : false;
    if (isCollection ==  true) {
        var allItems = $("#collection-items .product");
        $("#collection-viewer").addClass('loading').before('<div class="spinner container"></div>');
        allItems.css({opacity: 0})
    }
});

$(window).load(function(){
    var isCollection = $('body').hasClass('collection') ? true : false;
    var pH = 0;
    if (isCollection ==  true) {

        var 
        allItems = $("#collection-items .product").length
        pD = $("#collection-items .product .details");

        var i=0;
        for ( i = 0; i <= allItems; i++) {
            var height = pD.eq(i).height() + 20;
            if( height > pH ) {
                pH = height;
            }
        }

        pD.height(pH);

        $("#collection-viewer").removeClass('loading');
        $('.spinner').remove();
        $("#collection-items .product").animate({opacity: 1});
    }
});

function linkifyTweet(tweetText) {
    return tweetText
        .replace(/((ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&?!\-\/]))?)/gi,'<a href="$1">$1</a>')
        .replace(/(^|\s)#(\w+)/g,'$1<a href="http://search.twitter.com/search?q=$2">#$2</a>')
        .replace(/(^|\s)@(\w+)/g,'$1<a href="http://twitter.com/$2">@$2</a>');
}

function relativeTime(time_value) {
    var parsed_date = parseDate(time_value);
    var relative_to = (arguments.length > 1) ? arguments[1] : new Date();
    var delta = parseInt((relative_to.getTime() - parsed_date) / 1000);
    if(delta < 60) {
        return 'less than a minute ago';
    } else if(delta < 120) {
        return 'about a minute ago';
    } else if(delta < (45*60)) {
        return (parseInt(delta / 60)).toString() + ' minutes ago';
    } else if(delta < (90*60)) {
        return 'about an hour ago';
    } else if(delta < (24*60*60)) {
        return 'about ' + (parseInt(delta / 3600)).toString() + ' hours ago';
    } else if(delta < (48*60*60)) {
        return '1 day ago';
    } else {
        return (parseInt(delta / 86400)).toString() + ' days ago';
    }
}

function parseDate(str) {
    var v=str.split(' '), year, time;
    if (/\+0000/.test(v[5])) {
        year = v[3];
        time = v[4]
    } else {
        year = v[5]
        time = v[3]
    }
    return new Date(Date.parse(v[1]+" "+v[2]+", "+year+" "+time+" UTC"));
}
